module.exports = __webpack_public_path__ + "static/film6-52f9c58038ec86cc71c34fc9f138fb5f.jpg";